module.exports = {"name":"ContentOptimization","parameters":[{"name":"enableContentChangeReview","value":false},{"name":"renderNewTable","value":false}]}